import { activityBaseApi } from "activity/redux/api/activityBaseApi";

export const activityComboApi = activityBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getAllCombos: build.query<any, string>({
      query: () => `combo/getAllCombos`,
    }),
  }),
  overrideExisting: false,
});
